import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Document, OrderDocumentsService } from 'app/shared/services/order-documents/order-documents.service';
import { FailedUpload, WebSocketService } from 'app/shared/services/web-socket/web-socket.service';
import { config } from 'config';
import moment from 'moment-timezone';

export interface QRCodeUploadPayload {
  order_id?: number;
  user_id: number;
  expiry_time: string;         // ISO string format
  unique_order_id?: number;
  email: string;
  tag_ids?: number[];
  file_name?: string;
}

export interface QRCodeUploadDialogData {
  payload: QRCodeUploadPayload;
  title?: string;
  description?: string;
  actionButtonConfig?: {
    label: string;
    onClick: () => void;
    show?: boolean;
  };
}

@Component({
  selector: 'app-dialog-qr-code-upload',
  templateUrl: './dialog-qr-code-upload.component.html',
  styleUrls: ['./dialog-qr-code-upload.component.scss']
})
export class DialogQrCodeUploadComponent implements OnInit, OnDestroy {
  @Input() qrCodeDataUrl: string;
  expiryTimeFormatted: string = '';
  uploadedDocuments: Document[] = [];
  failedUploads: FailedUpload[] = [];
  token: string;

  constructor(public dialogRef: MatDialogRef<DialogQrCodeUploadComponent>,
    @Inject(MAT_DIALOG_DATA) public data: QRCodeUploadDialogData,
    private documentsService: OrderDocumentsService,
    private ws: WebSocketService) {
    const expiryTime = data?.payload?.expiry_time;
    if (expiryTime) {
      this.expiryTimeFormatted = moment(expiryTime).format('MMMM Do YYYY, h:mm A');
    }
  }

  ngOnInit(): void {
    this.generateQRCodeLink();
  }

  ngOnDestroy(): void {
    this.ws.unsubscribe(this.token)
  }

  generateQRCodeLink(): void {
    const payloadToSend: QRCodeUploadPayload = {
      ...this.data.payload,
      tag_ids: this.data.payload.tag_ids ?? []
    };
    this.documentsService.generateQRCodeLink(payloadToSend).subscribe((hash) => {
      this.token = hash as unknown as string;
      this.qrCodeDataUrl = `${config.widgetBaseUrl}upload/document/${hash}`;
      this.listenForUploadStatus(hash as unknown as string);
    })
  }

  private listenForUploadStatus(sessionId: string): void {
    this.ws.listenToUploadStatus(
      sessionId,
      (document: Document) => {
        console.log('✅ Document uploaded!', document);
        // Handle uploaded document if needed
        this.uploadedDocuments.push(document);
      },
      (error: FailedUpload) => {
        console.error('❌ Upload failed:', error);
        // Optionally show error to user
        this.failedUploads.push(error);
      }
    );
  }

  close(): void {
    this.dialogRef.close(true);
  }

  handleCustomAction(): void {
    if (this.data?.actionButtonConfig?.onClick) {
      this.data.actionButtonConfig.onClick();
    }
  }
}
